module.exports = __webpack_public_path__ + "static/media/Logo_Cancun.c477b39a.png";